import script from "./ScheduleRequirements.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScheduleRequirements.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__